var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.53 6.275L5.58 7.582a1.61 1.61 0 00-1.44 1.607v11.13h14.39V6.274zm0 17.27H4.14V34.68a1.61 1.61 0 001.44 1.606l12.95 1.306V23.546zm3.198 14.372v-14.37h17.588v14.361a1.604 1.604 0 01-1.759 1.606l-15.829-1.597zm0-17.597V5.951l15.83-1.597a1.604 1.604 0 011.758 1.606v14.358H21.728v.002z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsIcon);
export default __webpack_public_path__ + "static/media/windows-icon.293a81073397b11007e8db24f8163bd6.svg";
export { ForwardRef as ReactComponent };